import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {TokenService} from '../../../../shared/services/token.service';
import {Notification} from '../../../../shared/models/notification/notification';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {AngularFireMessaging} from '@angular/fire/compat/messaging';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {Router} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  /**
   * Notifications
   */
  notifications: Notification[];

  /**
   * Elements to be displayed in ui
   */
  elementsNumber = 7;

  /**
   * Date formatted
   */
  dateFormat = GeneralConstant.DATE_FORMAT;

  /**
   * Socket message
   */
  message: any;

  /**
   * Valid Token
   */
  validToken = false;

  constructor(private restService: RestService,
              private tokenService: TokenService,
              private datePipe: DatePipe,
              private afMessaging: AngularFireMessaging,
              private router: Router,
              public dialogRef: MatDialogRef<NotificationsComponent>) {
  }

  ngOnInit(): void {
    this.getAllNotifications();
    this.setReadNotifications();
    this.hasValidToken();
  }

  /**
   * Get All notifications
   */
  getAllNotifications() {
    this.restService.request<Notification[]>(
      RequestMethod.GET,
      ApiEndpoints.NOTIFICATION.NOTIFICATION,
      `${Actions.BASE_ACTIONS.READ}/${this.tokenService.getUserFromToken().contact.id}`,
    ).subscribe(response => {
      this.notifications = response.data;
    });
  }

  /**
   * Returns true/false based on his token
   */
  hasValidToken() {
    this.restService.request<any>(
      RequestMethod.GET,
      ApiEndpoints.NOTIFICATION.TOKEN,
      `${Actions.BASE_ACTIONS.VALID}`,
    ).subscribe(response => {
      this.validToken = response.data;
    });
  }

  /**
   * Set Read true to the notifications
   */
  setReadNotifications() {
    this.restService.request<any>(
      RequestMethod.PUT,
      ApiEndpoints.NOTIFICATION.NOTIFICATION,
      `update/${this.tokenService.getUserFromToken().contact.id}`,
    ).subscribe();
  }

  /**
   * Request Socket Notifications
   */
  requestPermission(event: MatSlideToggleChange) {
    if (event.checked) {
      this.afMessaging.requestPermission.subscribe({
        next: () => {
          this.afMessaging.tokenChanges.subscribe({
            next: (token: string | null) => {
              this.saveToken(token);
            },
            error: (error) => {
              console.error(error);
            }
          });
        },
        error: (error) => {
          console.error(error);
        }
      });
    } else {
      this.deleteBrowserToken();
    }
  }

  /**
   * Delete browser token
   */
  deleteBrowserToken() {
    this.afMessaging.getToken.subscribe({
      next: (token: string | null) => {
        this.deleteToken();
        this.afMessaging.deleteToken(token).subscribe();
      }
    });
  }

  /**
   * Save user token
   */
  saveToken(createdToken?: string) {
    this.restService.request<Notification[]>(
      RequestMethod.POST,
      ApiEndpoints.NOTIFICATION.TOKEN,
      `create`,
      {
        params: {
          token: createdToken
        }
      }
    ).subscribe();
  }

  /**
   * Delete user token
   */
  deleteToken() {
    this.restService.request<Notification[]>(
      RequestMethod.PUT,
      ApiEndpoints.NOTIFICATION.TOKEN,
      `delete`,
    ).subscribe();
  }

  redirectTo(url: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([url]);
      this.dialogRef.close();
    });
  }
}
